import {queries} from '@/shared/integrations/zero'
import {useQuery} from '@rocicorp/zero/react'

export function useGetUserCredentialAccount(userId: string | undefined) {
  return useQuery(queries.users.getUserCredentialAccount(userId || ''))
}
